import { Box } from '@mui/material';
import React from 'react';

const LogoContainer = () => {

    const logoContainerStyle = {
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: '150px',
        backgroundColor: 'transparent',
        marginBottom: '2.4rem',
        marginRight: '0.6rem',
        zIndex: 999
    };

    const imageStyle = {
        width: '100%', // Makes the image scale to the width of the Box
        height: 'auto', // Keeps the image aspect ratio intact
    };

    return (
        <Box
            component={"div"}
            sx={logoContainerStyle}
        >
            <img
                src={"/img/immersight_logo.png"}
                alt="Logo"
                style={imageStyle}
            />
        </Box>
    );
};

export default LogoContainer;
